// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__xj3tF","dragIcon":"Choice_dragIcon__38yns","left":"Choice_left__1r_hn","input":"Choice_input__1lGsE"};